export default __webpack_public_path__ + "static/media/search-icon.beaea768.svg";